<template>
    <div class="form__field">
        <label
            v-if="label"
            class="input__label"
        >
            {{ label | capitalize }}
        </label>
        <div style="position: relative;">
            <input
                class="input__field"
                :value="internalValue"
                v-bind="$attrs"
                @input="onInput"
                @blur="onBlur"
                @keypress="onKeyPress"
                ref="input"
            >
            <div
                v-if="unit"
                class="input__unit"
            >
                {{ unit }}
            </div>
        </div>
        <div
            v-if="errorMessage"
            class="message message--error"
        >
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { twoDecimals } from '@shared/filters';

    const DEFAULT_VALUE = '';

    export default Vue.component('NumberInput', {
        props: {
            value: {
                type: [Number, String],
                required: false,
                default: null,
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            unit: {
                type: String,
                default: null,
            },
            errorMessage: {
                type: String,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                isDirty: false,
                internalValue: DEFAULT_VALUE,
            };
        },
        created() {
            // decimalSeparator depends on current locale!
            // 11.11 are just a probe number, it could be any other decimal
            this.decimalSeparator = twoDecimals(11.11).toString().indexOf('.') !== -1 ? '.' : ',';
            this.wrongDecimalSeparator = this.decimalSeparator === '.' ? ',' : '.';
            this.internalValue = this.valueAsString(this.value);
        },
        watch: {
            value(newValue) {
                if (newValue) {
                    this.internalValue = newValue.toString().replace('.', this.decimalSeparator);
                } else {
                    this.internalValue = newValue;
                }
            }
        },
        computed: {
            internalValueAsNumber() {
                if (!this.internalValue) {
                    return this.internalValue;
                }
                const value = this.internalValue.replace(',', '.');
                return parseFloat(value);
            }
        },
        methods: {
            onKeyPress(e) {
                const charCode = e.which ? e.which : e.keyCode;
                const comma = 44;
                const dot = 46;

                if ([comma, dot].includes(charCode) && this.alreadyContainsDecimalSeparator()) {
                    e.preventDefault();
                }

                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (![comma, dot].includes(charCode))) {
                    e.preventDefault();
                }
            },
            onInput(e) {
                this.isDirty = true;
                let targetValue = e.target.value;

                if (targetValue && !parseFloat(targetValue)) {
                    targetValue = '';
                }

                targetValue = targetValue.replace(this.wrongDecimalSeparator, this.decimalSeparator);
                this.internalValue = this.trimTo2Decimals(targetValue);
                this.$forceUpdate();

                if (!targetValue) {
                    this.$emit('input', null);
                    this.$emit('valueChanged', null, this.name);
                    return;
                }
                this.$emit('input', this.internalValueAsNumber);
                this.$emit('valueChanged', this.internalValueAsNumber, this.name);
            },
            onBlur() {
                this.$emit('blur', this.name, this.internalValueAsNumber, this.isDirty);
            },
            focusInput() {
                this.$refs.input.focus();
            },
            alreadyContainsDecimalSeparator() {
                return this.internalValue.toString().includes(this.decimalSeparator);
            },
            trimTo2Decimals(value) {
                if (!value) {
                    return value;
                }
                const tokens = value.split(this.decimalSeparator);

                if (tokens[1] && tokens[1].length > 2) {
                    return value.slice(0, -(tokens[1].length - 2));
                }

                return value;
            },
            valueAsString(value) {
                if (!value) {
                    return DEFAULT_VALUE;
                }
                value = value.toString().replace(this.wrongDecimalSeparator, this.decimalSeparator);
                return this.trimTo2Decimals(value);
            },
        },
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/forms/NumberInput.vue